import { useContext, useEffect } from 'react';
import { SmartContext } from '../../../../library/Core/SmartContext';
import { isEmpty } from '../../../../library/Core/SmartFunctions';
import useManagementDashboard from './useManagementDashboard';
import BarChartComponent from '../../../../library/SimpleControls/BarChartComponent';

const TopBatches = () => {
    const { state } = useContext(SmartContext);
    const { getTopBatches } = useManagementDashboard();

    useEffect(() => {
        getTopBatches();
    }, [state.data.searchCriteria.topbatches]);

    if (isEmpty(state.data?.reportData?.topbatches)) return null;

    return (
        <>
            <BarChartComponent data={state.data.reportData.topbatches} />
        </>
    );
};

export default TopBatches;
